var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var GoogleMap = function () {
            function GoogleMap() {
                _classCallCheck(this, GoogleMap);

                this.map = null;
                this.marker = null;
                this.mapScriptLoaded = false;
                this.mapInitialized = false;

                this.mapPromise = null;
                this.bindEvents();
            }

            _createClass(GoogleMap, [{
                key: "getModalType",
                value: function getModalType(type) {
                    return type === 'floating' ? window.modal.types.FLOATING : window.modal.types.FULL;
                }
            }, {
                key: "getHeaderTheme",
                value: function getHeaderTheme(type) {
                    return type === 'floating' ? window.modal.themes.DEFAULT : window.modal.themes.PRIMARY;
                }
            }, {
                key: "openMapModal",
                value: function openMapModal(trigger, onAfterShow) {
                    var modalType = this.getModalType(trigger.dataset.modalType);

                    window.modal.open({
                        content: {
                            htmlDetachSelectorId: 'hotelMapLocationModal'
                        },
                        header: {
                            title: trigger.dataset.modalTitle || '',
                            theme: this.getHeaderTheme(trigger.dataset.modalType)
                        },
                        footer: false,
                        type: modalType,
                        parentCssClass: 'hotel-map-location-sheet',
                        onAfterShow: onAfterShow
                    });
                }
            }, {
                key: "loadMapScript",
                value: function loadMapScript() {
                    var _this = this;

                    if (this.mapPromise) return this.mapPromise;
                    this.mapPromise = window.loadGoogleMaps(window.app.googleMapApiToken).then(function () {
                        _this.mapScriptLoaded = true;
                    }).catch(function (error) {
                        _this.mapPromise = null;throw error;
                    });
                    return this.mapPromise;
                }
            }, {
                key: "bindEvents",
                value: function bindEvents() {
                    var _this2 = this;

                    // Вызов карты отеля с блока туров виджета Tours
                    document.addEventListener('click', function (event) {
                        var trigger = event.target.closest('.js-toggle-map-modal');
                        if (!trigger) {
                            return;
                        }

                        var lat = parseFloat(trigger.dataset.lat);
                        var lng = parseFloat(trigger.dataset.lng);

                        _this2.loadMapScript().then(function () {
                            _this2.openMapModal(trigger, function () {
                                _this2.handleMapModalClick({ lat: lat, lng: lng });
                                _this2.handleWindowResize();
                            });
                        }).catch(function (error) {
                            console.error('Google Maps loading failed:', error);
                        });
                    });

                    window.addEventListener('resize', function () {
                        _this2.handleWindowResize();
                    });
                }
            }, {
                key: "handleMapModalClick",
                value: function handleMapModalClick(coordinates) {
                    if (!this.mapInitialized) {
                        this.initMap(coordinates);
                    }

                    this.updateMapLocation(coordinates);
                }
            }, {
                key: "initMap",
                value: function initMap(coordinates) {
                    this.map = new google.maps.Map(document.getElementById('hotelMap'), {
                        zoom: 15,
                        center: coordinates
                    });

                    this.marker = new google.maps.Marker({
                        position: coordinates,
                        map: this.map
                    });
                    this.mapInitialized = true;
                }
            }, {
                key: "updateMapLocation",
                value: function updateMapLocation(coordinates) {
                    this.map.setCenter(coordinates);
                    this.marker.setPosition(coordinates);
                }
            }, {
                key: "handleWindowResize",
                value: function handleWindowResize() {
                    if (this.mapInitialized && window.google && google.maps.event) {
                        // Триггерим событие 'resize' для карты
                        google.maps.event.trigger(this.map, 'resize');
                        // Обновляем центр карты
                        if (this.map.getCenter()) {
                            this.map.setCenter(this.map.getCenter());
                        }
                    }
                }
            }]);

            return GoogleMap;
        }();

        if (window.app && window.app.googleMapApiToken) {
            window.mapModalInstance = new GoogleMap();
        }
    }, {}] }, {}, [1]);